import React from "react";

import { Loader, Box, Map } from "shipnow-mercurio";

import PropTypes from "prop-types";
import { NotFoundOptions } from "..";

const DEFAULT_PROPS = {
  options: [],
  buyerAddress: null,
  isLoadingBranches: false,
  selectedOption: null,
  order: null,
  clearShippingOptions: null,
  onSelectCarrier: null,
  margin: "a-0",
};

export const CarrierMap = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  const handleClearOption = () => {
    attrs.clearShippingOptions(attrs.order.isReturn);
  };

  const handleSelectOption = (_option) => {
    if (!_option) return;
    const option = _option.model;
    attrs.onSelectCarrier(option);
  };

  const handleMarkerClick = (option) => {
    handleSelectOption(option);
  };

  if (attrs.isLoadingBranches) {
    return (
      <Box margin="t-10" height="300px">
        <Loader />
      </Box>
    );
  }

  if (attrs.options.length > 0) {
    return (
      <Box margin={attrs.margin}>
        <Map
          key={attrs.options}
          width="100%"
          height="460px"
          homeMarker={{
            position: [attrs.buyerAddress?.lat, attrs.buyerAddress?.lon],
          }}
          onMarkerClick={handleMarkerClick}
          selectedOption={attrs.selectedOption}
          listOptions={attrs.options.map((option) => {
            const addressInfo = attrs.order.isReturn
              ? option.ship_from.address
              : option.ship_to.address;

            return {
              model: option,
              id: option.id,
              carrierName: option.shipping_service.carrier.name,
              streetName: addressInfo.street_name,
              addressLine: addressInfo.address_line,
              streetNumber: addressInfo.street_number,
              city: addressInfo.city,
              state: addressInfo.state,
              lat: addressInfo.lat,
              lon: addressInfo.lon,
            };
          })}
          zoomControl={false}
          onSelectOption={handleSelectOption}
          onClearOption={handleClearOption}
          showList
        />
      </Box>
    );
  }
  return (
    <Box margin={attrs.margin}>
      <NotFoundOptions />
    </Box>
  );
};

CarrierMap.propTypes = {
  setSelectedOption: PropTypes.func,
  options: PropTypes.array,
  buyerAddress: PropTypes.object,
  isLoadingBranches: PropTypes.bool,
  selectedOption: PropTypes.object,
  order: PropTypes.object,
  clearShippingOptions: PropTypes.func,
  onSelectCarrier: PropTypes.func,
  margin: PropTypes.string,
};
